import Tooltip, { tooltipClasses, TooltipProps } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';

export const useResourceFieldStyles = () => ({
  formWrapper: {
    width: '100%',
    flexDirection: 'column',
    display: 'flex',
    '& .MuiInputLabel-root': {
      opacity: 1,
      marginLeft: '0px !important',
    },
    '& .MuiFormControlLabel-root': {
      marginLeft: '-5px !important',
    },
    '& input': {
      color: '#000',
      border: 'none',
      borderRadius: 4,
    },
    '& input::placeholder': {
      fontSize: '14px',
      color: '#000',
    },
    '& .MuiOutlinedInput-input': {
      padding: '0px !important',
      paddingLeft: '16px !important',
    },
    '& .MuiAutocomplete-inputRoot': {
      padding: '2px 8px !important',
      background: '#fff !important',
    },
    '& .MuiOutlinedInput-root': {
      background: 'rgba(0,0,0,0.05)',
      '&.Mui-focused fieldset': {
        borderRadius: 4,
        border: '1px solid rgb(242, 121, 33)',
      },
      '&:hover fieldset': {
        border: '1px solid rgb(242, 121, 33)',
        borderRadius: 4,
      },
      '& fieldset': {
        borderRadius: 4,
        color: '#000',
        fontSize: '12px',
      },
      '& .MuiChip-deleteIcon': {
        backgroundColor: 'transparent',
      },
      '& .MuiAutocomplete-endAdornment': {
        '& .MuiButtonBase-root': {
          width: 'auto !important',
          '& .MuiSvgIcon-root': {
            color: '#233759',
          },
        },
      },
    },

    dropdownHeading: {
      color: 'rgba(95, 109, 131, 1)',
      padding: '16px 0px 8px 16px',
      textTransform: 'uppercase',
      fontSize: '14px',
    },
    renderOptionList: {
      display: 'flex !important',
      alignItems: 'center !important',
      justifyContent: 'space-between !important',
    },
    listItemButton: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '8px 0px',
    },
  },
  footerButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    padding: '8px 0px',
    borderTop: '1px solid rgba(0, 0, 0, 0.12)',
  },
  dropDownHeading: {
    color: 'rgba(95, 109, 131, 1)',
    padding: '16px 0px 8px 16px',
    textTransform: 'uppercase',
    fontSize: '14px',
    fontFamily: 'Roboto',
  },
});

export const LightTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} arrow />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    color: 'rgba(0, 0, 0, 0.87)',
    boxShadow: theme.shadows[2],
    fontSize: 11,
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.common.white,
  },
}));
